module.exports = __webpack_public_path__ + "img/s_pinkpinkT-logo.215dfa7.png";